module.exports = __webpack_public_path__ + "static/media/majors-students-class.2694e393.jpg";